import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

// Simple markdown to HTML converter for legal pages
const parseMarkdown = (text) => {
  if (!text) return '';
  
  let html = text
    // Headers
    .replace(/^### (.*$)/gim, '<h3 class="text-lg font-semibold text-slate-100 mt-8 mb-3">$1</h3>')
    .replace(/^## (.*$)/gim, '<h2 class="text-xl font-bold text-slate-100 mt-10 mb-4">$1</h2>')
    .replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold text-slate-100 mt-8 mb-6">$1</h1>')
    // Bold
    .replace(/\*\*(.*?)\*\*/gim, '<strong class="text-slate-200">$1</strong>')
    // Lists
    .replace(/^\- (.*$)/gim, '<li class="ml-4 text-slate-400 mb-1">$1</li>')
    // Line breaks for new paragraphs
    .replace(/\n\n/gim, '</p><p class="text-slate-400 leading-relaxed mb-4">')
    .replace(/\n/gim, '<br />');

  // Wrap lists in ul
  if (html.includes('<li')) {
    html = html.replace(/(<li[^>]*>.*?<\/li>\s*)+/gim, (match) => `<ul class="my-4 space-y-1">${match}</ul>`);
  }

  return html;
};

export default function Legal() {
  const location = useLocation();
  const { t } = useLanguage();
  
  // Extract page from pathname
  const pathParts = location.pathname.split('/');
  const page = pathParts[pathParts.length - 1];

  const getContent = () => {
    switch (page) {
      case 'terms':
        return {
          title: t.legal.termsTitle,
          content: t.legal.termsContent,
        };
      case 'privacy':
        return {
          title: t.legal.privacyTitle,
          content: t.legal.privacyContent,
        };
      case 'commercial-terms':
        return {
          title: t.legal.commercialTitle,
          content: t.legal.commercialContent,
        };
      default:
        return {
          title: 'Page Not Found',
          content: '',
        };
    }
  };

  const { title, content } = getContent();

  return (
    <div className="relative">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 to-slate-950" />
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-outfit text-3xl sm:text-4xl font-bold text-slate-100 tracking-tight">
            {title}
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 lg:py-16 bg-slate-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div 
            className="prose prose-invert prose-sm max-w-none"
            dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
          />
        </div>
      </section>
    </div>
  );
}
